import { render, staticRenderFns } from "./HoloverzWhitePaper.vue?vue&type=template&id=6976f7fa&scoped=true"
import script from "./HoloverzWhitePaper.vue?vue&type=script&lang=js"
export * from "./HoloverzWhitePaper.vue?vue&type=script&lang=js"
import style0 from "./HoloverzWhitePaper.vue?vue&type=style&index=0&id=6976f7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6976f7fa",
  null
  
)

export default component.exports